import { WidgetInteractionEnum } from '../models/widget-interaction.enum';
import { AnalyticResponseModel } from '../models/analytic-response.model';
import { WidgetUserTypeEnum } from '../models/widget-user-type.enum';
import { WidgetUrlConfig } from 'src/app/widget-config/initial-config';
import { UIConfig } from '../../shared/widget-wiring';
import { WidgetProductSetting } from './widget.state.model';

export class SetupWidget {
  static readonly type = '[Widget] Setup Widget';
  constructor(
    public hostingURL: string,
    public embedded: boolean,
    public widgetConfig: WidgetUrlConfig,
  ) {}
}

export class LogWidgetInteraction {
  static readonly type = '[Widget] Log Interaction';
  constructor(public interaction: WidgetInteractionEnum, public source?: string) {}
}

export class LogWidgetInteractionSuccess {
  static readonly type = '[Widget] Log Interaction Success';
  constructor(public interaction: WidgetInteractionEnum, public response: AnalyticResponseModel) {}
}

export class LogWidgetInteractionFailure {
  static readonly type = '[Widget] Log Interaction Failure';
  constructor(public interaction: WidgetInteractionEnum, public response: AnalyticResponseModel) {}
}

export class AuthWidget {
  static readonly type = '[Widget] Auth';
  constructor() {}
}

export class AuthWidgetSuccess {
  static readonly type = '[Widget] Auth Success';
  constructor(public userType: WidgetUserTypeEnum, public response: AnalyticResponseModel) {}
}

export class AuthWidgetFailure {
  static readonly type = '[Widget] Auth Failure';
  constructor(public userType: WidgetUserTypeEnum, public response: AnalyticResponseModel) {}
}

export class ResetWidget {
  static readonly type = '[Widget] Reset';
  constructor() {}
}

export class SetInputEnabled {
  static readonly type = '[Widget] Set Input Enabled';
  constructor(public enabled: boolean) {}
}

export class SetWidgetApiConfig {
  static readonly type = '[Widget] Set API Config';
  constructor(public config: UIConfig) {}
}

export class GetWidgetProductSettings {
  static readonly type = '[Widget] Get Widget Product Settings';
  constructor(public productAccountId: string) {}
}

export class SetWidgetProductSettings {
  static readonly type = '[Widget] Set Widget Product Settings';
  constructor(public widgetSettings: WidgetProductSetting[]) {}
}
